import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http, gradeLabel } from "@/lib/api";
import { SubjectIcon } from "@/lib/subjects";
import { RecordShell } from "@/components/records/RecordShell";

const Chips = ({ label, items }) => items.length > 0 && (
  <div>
    <p className="text-xs uppercase tracking-widest text-stone-500 font-semibold">{label}</p>
    <div className="flex flex-wrap gap-2 mt-2">{items.map((t, i) => <span key={i} className="px-3 py-1 rounded-full bg-[#F7F3EB] text-sm text-stone-700">{t}</span>)}</div>
  </div>
);

export default function Portfolio() {
  const { studentId } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { http.get(`/students/${studentId}/portfolio`).then((r) => setD(r.data)).catch(() => setErr("You don't have access to this portfolio.")); }, [studentId]);
  if (err) return <p className="text-center py-20 text-stone-500" data-testid="record-error">{err}</p>;
  if (!d) return <p className="text-center py-20 text-stone-500">Loading…</p>;

  return (
    <RecordShell title="Self-Discovery Portfolio" back testId="portfolio-page">
      <div className="mt-8">
        <p className="text-xs uppercase tracking-[0.25em] text-[#C87D53] font-semibold">Who I really am</p>
        <h1 className="font-display text-4xl text-[#2C4A3E] mt-2" data-testid="portfolio-student-name">{d.student.name}</h1>
        <p className="text-stone-500 mt-1">{gradeLabel(d.student.grade)} · {d.stats.lessons_completed} reflections across {d.sections.length} subjects · {d.stats.mindful_minutes} mindful minutes</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-6 mt-8">
        <Chips label="My intentions" items={[...new Set(d.intentions)]} />
        <Chips label="I'm grateful for" items={[...new Set(d.gratitude)]} />
      </div>
      {d.sections.map((s) => (
        <section key={s.subject_id} className="mt-12 break-inside-avoid" data-testid={`portfolio-section-${s.subject_id}`}>
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-2xl grid place-items-center" style={{ background: s.color }}><SubjectIcon name={s.icon} className="w-4 h-4 text-white" /></span>
            <div>
              <p className="font-display text-xl text-[#2C4A3E]">{s.subject_name}</p>
              <p className="font-display italic text-sm text-[#C87D53]">"{s.self_question}"</p>
            </div>
          </div>
          <div className="mt-4 space-y-3 border-l-2 border-[#E6DEC3] pl-5 ml-5">
            {s.entries.map((e) => (
              <article key={e.id} className="break-inside-avoid" data-testid={`portfolio-entry-${e.id}`}>
                <p className="text-xs text-stone-500">{new Date(e.created_at).toLocaleDateString()} · {e.topic}</p>
                <p className="text-stone-700 leading-relaxed mt-1 whitespace-pre-line">{e.reflection}</p>
              </article>
            ))}
          </div>
        </section>
      ))}
      {!d.sections.length && <p className="text-center text-stone-500 py-16" data-testid="portfolio-empty">Complete a mindful lesson to begin your portfolio.</p>}
    </RecordShell>
  );
}
